"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompactInlineAlertWidget = exports.CompactAlertStyleName = exports.InteractiveIconClass = exports.InteractiveAlertClass = exports.InlineAlertType = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var TypeStyle = tslib_1.__importStar(require("typestyle"));
var AlertStyles_1 = require("../AlertStyles");
var InlineAlertBase_1 = require("./InlineAlertBase");
Object.defineProperty(exports, "InlineAlertType", { enumerable: true, get: function () { return InlineAlertBase_1.InlineAlertType; } });
exports.InteractiveAlertClass = 'interactiveAlert';
exports.InteractiveIconClass = 'interactiveIconContainer';
exports.CompactAlertStyleName = TypeStyle.style({
    minHeight: 24,
    $nest: (_a = {},
        _a["& ." + InlineAlertBase_1.MessageClass] = {
            flexGrow: 1,
            margin: "3px 8px",
        },
        _a["& ." + exports.InteractiveIconClass] = {
            flexShrink: 0,
            margin: "6px 8px 0px 8px",
        },
        _a["&." + exports.InteractiveAlertClass] = {
            cursor: 'pointer',
            $nest: (_b = {},
                _b["&." + InlineAlertBase_1.InlineAlertType.Success + ":hover"] = {
                    backgroundColor: AlertStyles_1.ColorMap.success.hoverColor,
                },
                _b["&." + InlineAlertBase_1.InlineAlertType.Info + ":hover"] = {
                    backgroundColor: AlertStyles_1.ColorMap.info.hoverColor,
                },
                _b["&." + InlineAlertBase_1.InlineAlertType.Warning + ":hover"] = {
                    backgroundColor: AlertStyles_1.ColorMap.warning.hoverColor,
                },
                _b["&." + InlineAlertBase_1.InlineAlertType.Error + ":hover"] = {
                    backgroundColor: AlertStyles_1.ColorMap.error.hoverColor,
                },
                _b),
        },
        _a),
});
exports.CompactInlineAlertWidget = React.forwardRef(function (props, ref) {
    var className = props.className, icon = props.icon, iconContainerStyle = props.iconContainerStyle, inlineAlertProps = tslib_1.__rest(props, ["className", "icon", "iconContainerStyle"]);
    var InteractiveIcon = function (interactiveIcon) {
        return React.createElement("div", { children: interactiveIcon, className: exports.InteractiveIconClass, style: iconContainerStyle });
    };
    return (React.createElement(InlineAlertBase_1.InlineAlert, tslib_1.__assign({}, inlineAlertProps, { className: TypeStyle.classes(className, exports.CompactAlertStyleName, inlineAlertProps.onClick && exports.InteractiveAlertClass), interactiveElement: icon && InteractiveIcon(icon), ref: ref })));
});
exports.CompactInlineAlertWidget.displayName = 'CompactInlineAlertWidget';
//# sourceMappingURL=CompactInlineAlertWidget.js.map